import { iconFactory } from './icon.factory.ts'

export default iconFactory(
    `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="535"
   height="535"
   viewBox="0 0 501.56251 501.56249"
   id="svg2"
   version="1.1"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25)"
   sodipodi:docname="nix-snowflake-colours.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:dc="http://purl.org/dc/elements/1.1/">
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.70904368"
     inkscape:cx="99.429699"
     inkscape:cy="195.33352"
     inkscape:document-units="px"
     inkscape:current-layer="layer3"
     showgrid="false"
     inkscape:window-width="1920"
     inkscape:window-height="1050"
     inkscape:window-x="1920"
     inkscape:window-y="30"
     inkscape:window-maximized="1"
     inkscape:snap-global="true"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:showpageshadow="2"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1" />
  <g
     inkscape:groupmode="layer"
     id="layer3"
     inkscape:label="gradient-logo"
     style="display:inline;opacity:1"
     transform="translate(-156.41121,933.30685)">
    <g
       id="g2"
       transform="matrix(0.99994059,0,0,0.99994059,-0.06321798,33.188377)"
       style="stroke-width:1">
      <path
         sodipodi:nodetypes="cccccccccc"
         inkscape:connector-curvature="0"
         id="path3336-6"
         d="m 309.54892,-710.38827 122.19683,211.67512 -56.15706,0.5268 -32.6236,-56.8692 -32.85645,56.5653 -27.90237,-0.011 -14.29086,-24.6896 46.81047,-80.4901 -33.22946,-57.8257 z"
         style="opacity:1;fill:#7eb1dd;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:3.00018;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
      <use
         height="100%"
         width="100%"
         transform="rotate(60,407.11155,-715.78724)"
         id="use3439-6"
         inkscape:transform-center-y="151.59082"
         inkscape:transform-center-x="124.43045"
         xlink:href="#path3336-6"
         y="0"
         x="0"
         style="stroke-width:1" />
      <use
         height="100%"
         width="100%"
         transform="rotate(-60,407.31177,-715.70016)"
         id="use3445-0"
         inkscape:transform-center-y="75.573958"
         inkscape:transform-center-x="-168.20651"
         xlink:href="#path3336-6"
         y="0"
         x="0"
         style="stroke-width:1" />
      <use
         height="100%"
         width="100%"
         transform="rotate(180,407.41868,-715.7565)"
         id="use3449-5"
         inkscape:transform-center-y="-139.94592"
         inkscape:transform-center-x="59.669705"
         xlink:href="#path3336-6"
         y="0"
         x="0"
         style="stroke-width:1" />
      <path
         style="color:#000000;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;fill:#4a6baf;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:3.00018;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate"
         d="m 309.54892,-710.38827 122.19683,211.67512 -56.15706,0.5268 -32.6236,-56.8692 -32.85645,56.5653 -27.90237,-0.011 -14.29086,-24.6896 46.81047,-80.4901 -33.22946,-57.8256 z"
         id="path4260-0"
         inkscape:connector-curvature="0"
         sodipodi:nodetypes="cccccccccc" />
      <use
         height="100%"
         width="100%"
         transform="rotate(120,407.33916,-716.08356)"
         id="use4354-5"
         xlink:href="#path4260-0"
         y="0"
         x="0"
         style="display:inline;stroke-width:1" />
      <use
         height="100%"
         width="100%"
         transform="rotate(-120,407.28823,-715.86995)"
         id="use4362-2"
         xlink:href="#path4260-0"
         y="0"
         x="0"
         style="display:inline;stroke-width:1" />
    </g>
  </g>
</svg>`,
    (_, i) => i === 0,
)
